/* FileServerStatusComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./FileServerStatusRenderer");

const _ = require("lodash");

class FileServerStatusComponent extends EventEmitter {
    constructor(logger, eventEmitter, OsImageServerEntity) {
        super();
        this._logger = logger;
        this._eventEmitter = eventEmitter;

        this._registerListeners();
        this._renderer = new Renderer(this, OsImageServerEntity.IMAGE_SERVER_STATUS);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {
        this._eventEmitter.on("ImageServersUpdated", (this._onImageServersUpdated = this._onImageServersUpdated.bind(this)));
    }
    _unregisterListeners() {
        this._eventEmitter.removeListener("ImageServersUpdated", this._onImageServersUpdated);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._renderer.rootElement;
    }

    get logger() {
        return this.getLogger();
    }
    getLogger() {
        return this._logger;
    }

    render() {
        return this._renderer.render();
    }

    shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();
        this.removeAllListeners();
        return Promise.all([this._renderer.shutdown()]).then(
            () => {
                this._renderer = undefined;
                this._logger = undefined;
                this._userSession = undefined;
            },
            (error) => {
                this._logger.warn({ error }, "FileServerStatusComponent.shutdown error");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onImageServersUpdated(servers) {
        this.setServers(servers);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    /**
     * @param {Array} servers
     */
    setServers(servers) {
        this.emit("Servers", _.toArray(servers));
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = FileServerStatusComponent;

FileServerStatusComponent.$inject = ["$teve.logger", "eventEmitter.eventEmitter", "$teve.entities.OsImageServer"];

FileServerStatusComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "common.duplicate",
    shown: false,
    order: 2
};
